import { InjectionToken } from '@angular/core';
import { Topic } from '../messaging-subscription.service';

export const TOPIC_STORAGE = new InjectionToken<TopicStorage>('Topic storage');

export interface TopicStorage {
  saveTopic(topic: Topic): void;

  deleteTopic(topic: Topic): void;

  getAllSubscribedTopics(): Topic[];
}
